import { PagoMiembroFields, pagoMiembroValido, pagoMiembroPayload } from "../eventos/PagoMiembroFields";
import React, { useMemo, useState } from "react";
import {
	Autocomplete,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	TextField,
} from "@mui/material";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import { AlertError } from "../../utils/componentes-utiles/AlertError";
import { postActividad } from "../../services/apis";

const getFechaHoy = () => {
	const hoy = new Date();
	const year = hoy.getFullYear();
	const month = String(hoy.getMonth() + 1).padStart(2, "0");
	const day = String(hoy.getDate()).padStart(2, "0");

	return `${year}-${month}-${day}`;
};

const formatTimeInputValue = (date) => {
	const hours = String(date.getHours()).padStart(2, "0");
	const minutes = String(date.getMinutes()).padStart(2, "0");

	return `${hours}:${minutes}`;
};

const getHorasPorDefecto = () => {
	const inicio = new Date();
	const final = new Date(inicio.getTime() + 30 * 60 * 1000);

	return {
		hora_inicio: formatTimeInputValue(inicio),
		hora_final: formatTimeInputValue(final),
	};
};

export const CrearActividadDialog = ({ open, onClose, opTrabajadores, onCreated }) => {
	const createInitialForm = () => ({
		miembro_paga: 0,
		precio_miembro: "",
		asunto: "",
		descripcion: "",
		fecha: getFechaHoy(),
		...getHorasPorDefecto(),
		usuario_encargado: null,
	});

	const initialForm = useMemo(() => createInitialForm(), []);
	const [form, setForm] = useState(initialForm);
	const [guardando, setGuardando] = useState(false);
	const [error, setError] = useState(false);
	const [mensajeError, setMensajeError] = useState("Falta rellenar algun campo obligatorio");

	const handleClose = () => {
		if (guardando) {
			return;
		}

		setForm(createInitialForm());
		onClose();
	};

	const updateField = (field, value) => {
		setForm((prev) => ({
			...prev,
			[field]: value,
		}));
	};

	const validar = () => {
		return Boolean(
			form.asunto.trim()
			&& form.fecha
			&& form.hora_inicio
			&& form.usuario_encargado?.value
		);
	};

	const crearActividad = async () => {
		if (!validar() || !pagoMiembroValido(form)) {
			setMensajeError("Falta rellenar algun campo obligatorio");
			setError(true);
			return;
		}

		setGuardando(true);
		try {
			const response = await postActividad({
				...pagoMiembroPayload(form),
				asunto: form.asunto.trim(),
				descripcion: form.descripcion.trim() || form.asunto.trim(),
				fecha: form.fecha,
				hora_inicio: form.hora_inicio,
				hora_final: form.hora_final || null,
				id_usuario_encargado: form.usuario_encargado.value,
			});

			if (response?.success) {
				setForm(createInitialForm());
				onCreated();
				onClose();
				return;
			}

			setMensajeError(response?.message || response?.error || "No se ha podido crear la actividad");
			setError(true);
		} catch (err) {
			console.error("Error al crear actividad:", err);
			setMensajeError("No se ha podido crear la actividad");
			setError(true);
		} finally {
			setGuardando(false);
		}
	};

	return (
		<Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
			<DialogTitle className="activity-create-title">
				<LocalActivityIcon />
				Crear actividad
			</DialogTitle>
			<DialogContent dividers>
				<Grid container spacing={2} className="activity-create-form">
					<Grid size={{ xs: 12 }}>
						<TextField
							fullWidth
							required
							label="Nombre"
							value={form.asunto}
							onChange={(event) => updateField("asunto", event.target.value)}
							inputProps={{ maxLength: 50 }}
						/>
					</Grid>
					<Grid size={{ xs: 12 }}>
						<TextField
							fullWidth
							multiline
							minRows={3}
							label="Descripcion"
							value={form.descripcion}
							onChange={(event) => updateField("descripcion", event.target.value)}
							inputProps={{ maxLength: 500 }}
						/>
					</Grid>
					<PagoMiembroFields form={form} onChange={updateField} />
					<Grid size={{ xs: 12, sm: 4 }}>
						<TextField
							fullWidth
							required
							label="Fecha"
							type="date"
							value={form.fecha}
							onChange={(event) => updateField("fecha", event.target.value)}
							InputLabelProps={{ shrink: true }}
						/>
					</Grid>
					<Grid size={{ xs: 12, sm: 4 }}>
						<TextField
							fullWidth
							required
							label="Hora inicio"
							type="time"
							value={form.hora_inicio}
							onChange={(event) => updateField("hora_inicio", event.target.value)}
							InputLabelProps={{ shrink: true }}
						/>
					</Grid>
					<Grid size={{ xs: 12, sm: 4 }}>
						<TextField
							fullWidth
							label="Hora final"
							type="time"
							value={form.hora_final}
							onChange={(event) => updateField("hora_final", event.target.value)}
							InputLabelProps={{ shrink: true }}
						/>
					</Grid>
					<Grid size={{ xs: 12 }}>
						<Autocomplete
							fullWidth
							options={opTrabajadores}
							value={form.usuario_encargado}
							onChange={(event, value) => updateField("usuario_encargado", value)}
							isOptionEqualToValue={(option, value) => option.value === value.value}
							renderInput={(params) => (
								<TextField {...params} required label="Usuario encargado" />
							)}
						/>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} disabled={guardando}>
					Cancelar
				</Button>
				<Button variant="contained" onClick={crearActividad} disabled={guardando}>
					{guardando ? "Creando..." : "Crear actividad"}
				</Button>
			</DialogActions>
			{error && (
				<AlertError open={error} setOpen={setError} titulo="Error" mensaje={mensajeError} />
			)}
		</Dialog>
	);
};
